<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      Monitoring GEF
    </div>
  </dxi-item>
</dx-toolbar>

<dx-data-grid
  [columnAutoWidth]="true"
  [dataSource]="data"
  keyExpr="id"
  class="data-grid"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  columnResizingMode="widget"
>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-filter-row [visible]="true"></dxo-filter-row>

  <dxi-column dataField="site" caption="Site" cellTemplate="templateSite" [allowHeaderFiltering]="false"></dxi-column>

  <dxi-column dataField="type" alignment="center" caption="Type"></dxi-column>

  <dxi-column dataField="libelle" alignment="center" caption="Libelle" cellTemplate="libelleCellTemplate" [allowHeaderFiltering]="false"></dxi-column>

  <div *dxTemplate="let cell of 'templateSite'">
    <ng-container *ngIf="cell.row.data.type === 'LotMarche'; else siteTpl ">
      <td>
        <yo-site [siteId]="cell.row.data.marche.site.id"></yo-site>
        {{ cell.row.data.marche.site.libelle }}
      </td>
    </ng-container>

    <ng-template #siteTpl>
      <td>
        <yo-site [siteId]="cell.row.data.site.id"></yo-site>
        {{ cell.row.data.site.libelle }}
      </td>
    </ng-template>
  </div>

  <div *dxTemplate="let cell of 'libelleCellTemplate'">
    <ng-container *ngIf="cell.data.type === 'Article'; else libelleTpl ">
      <a
        [title]="'Aller sur la fiche de l\'' + cell.data.type.toLowerCase()"
        (click)="redirectToPage(cell.data, cell.data.type)">
        <span class="cursor save-color"> {{ cell.data.produitArticle.libelle }}</span>
      </a>
    </ng-container>

    <ng-template #libelleTpl>
      <a
        [title]="'Aller sur la fiche du ' + cell.data.type.toLowerCase()"
        (click)="redirectToPage(cell.data, cell.data.type)">
        <span class="cursor save-color">{{ cell.data.libelle }}</span>
      </a>
    </ng-template>
  </div>

  <div *dxTemplate="let cell of 'siteCellTemplate'">
    <yo-site [siteLibelle]="cell.value.libelle"
             [siteId]="cell.value.id">
    </yo-site>
  </div>

  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[50, 100, 200]"
    [visible]="true"
    [showInfo]="true">
  </dxo-pager>

</dx-data-grid>



